module.exports = __webpack_public_path__ + "img/zf.5d2e9238.png";